'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSSPs]');

var winresServiceSelectPassengers = function () {
    function winresServiceSelectPassengers($scope) {
        _classCallCheck(this, winresServiceSelectPassengers);

        this.$scope = $scope;
    }

    _createClass(winresServiceSelectPassengers, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.values = [];
            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return _.toArray(value).length === 0;
            };
        }
    }, {
        key: 'render',
        value: function render(value) {
            this.values = _.fromPairs(_.map(value, function (id) {
                return [id, 1];
            }));
        }
    }, {
        key: 'read',
        value: function read() {
            var _this2 = this;

            var ids = _.map(this.passengers, function (p) {
                return p.id;
            });
            var value = _.filter(ids, function (id) {
                return _this2.values && _this2.values[id] > 0;
            });
            this.ngModelCtrl.$setViewValue(value);
            // log('Output:', value);
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.disabled !== undefined && this.disabled !== false;
        }
    }, {
        key: 'totalPrice',
        value: function totalPrice() {
            var _this3 = this;

            var selectedPassengers = _.filter(this.passengers, function (p) {
                return _this3.values && _this3.values[p.id] > 0;
            });
            return _.sumBy(selectedPassengers, function (p) {
                return p.price;
            });
        }
    }]);

    return winresServiceSelectPassengers;
}();

winresServiceSelectPassengers.$inject = ['$scope'];

_module3.default.component('winresServiceSelectPassengers', {
    template: require('./winresServiceSelectPassengers.html'),
    controller: winresServiceSelectPassengers,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        // List of passengers. NOTE: The id field is meant to be unique to each
        // passenger. It is used to detect when a passenger is added or removed,
        // so that the passenger's selection can also be removed.
        // [
        //     {
        //         id: 42
        //         name: 'John Smith',
        //         priceLabel: 'adult',
        //         price: 5
        //     },
        //     {
        //         id: 666,
        //         name: 'Mary Smith',
        //         priceLabel: 'child',
        //         price: 2.5
        //     }
        // ]
        passengers: '<',

        // The available capacity for the service.
        // NOTE: This is not the same thing as max.
        // Capacity is the amount of items in stock,
        // max is an arbitrary limit imposed by linking.
        capacity: '<',

        // IDs of selected passengers.
        ngModel: '<',

        // If this attribute is set (to anything), the component is disabled.
        disabled: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceSelectPassengers/winresServiceSelectPassengers.js
// module id = 455
// module chunks = 2